module.exports = {
      id: "arrow-shaded-usage",
      viewBox: "0 0 13 25",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#arrow-shaded-usage",
      toString: function () {
        return this.url;
      }
    }